var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoChatHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1494",
    "data-name": "Group 1494",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.574,
    height: 31.574,
    viewBox: "0 0 31.574 31.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1324",
    "data-name": "Rectangle 1324",
    width: 31.574,
    height: 31.574,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25752",
    "data-name": "Path 25752",
    d: "M22.324,0,9.246,0,0,9.251,0,22.329,9.25,31.575l13.078,0,9.246-9.248,0-13.078Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25753",
    "data-name": "Path 25753",
    d: "M235.476,214.982l-11.993,0L215,223.465v11.993l8.481,8.479,11.993,0,8.479-8.481,0-11.992Z",
    transform: "translate(-213.694 -213.673)",
    fill: "#d40000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25754",
    "data-name": "Path 25754",
    d: "M1577.631,780.962a1.094,1.094,0,0,0-1.094,1.094v8.607q-.275.021-.547.067V783.46a1.094,1.094,0,1,0-2.187,0v8.113a5.884,5.884,0,0,0-.547.392v-5.754a1.094,1.094,0,1,0-2.188,0v10.341h.006a5.9,5.9,0,0,0,7.8,5.6h0a5.914,5.914,0,0,0,3.312-2.8l0,0,3.744-6.968a1.343,1.343,0,0,0-2.367-1.271l-1.4,2.6a5.915,5.915,0,0,0-.711-1.021v-8.807a1.094,1.094,0,0,0-2.187,0v7.218q-.268-.113-.547-.2v-8.851a1.094,1.094,0,0,0-1.094-1.094Z",
    transform: "translate(-1561.498 -776.205)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChatHand);
export default __webpack_public_path__ + "static/media/no-chat-hand.8e78a432fa05a2b514389ed23197731f.svg";
export { ForwardRef as ReactComponent };